import { FC, useEffect } from 'react';
import { Center } from '@chakra-ui/react';

import Loader from 'components/Loader';
import { StepProps } from 'components/Stepper/types';
import useToast from 'components/ToastProvider/useToast';
import * as Layout from 'layouts/StepperLayout';

import useSubmitPaymentCardRequest from './hooks/useSubmitPaymentCardRequest';
import locales from './locales';

const Ordering: FC<StepProps> = ({ goNext }) => {
  const { called, loading, submitPaymentCardRequest } =
    useSubmitPaymentCardRequest();
  const { showToast } = useToast();

  useEffect(() => {
    if (called) {
      return;
    }

    submitPaymentCardRequest()
      .then(() => {
        showToast({
          message: locales.notification.success,
          type: 'success',
        });
      })
      .catch(() => {
        showToast({
          message: locales.notification.error,
          type: 'error',
        });
      })
      .finally(() => {
        goNext();
      });
  }, [called, goNext, showToast, submitPaymentCardRequest]);

  if (!loading) {
    return null;
  }

  return (
    <Layout.Root>
      <Layout.Body>
        <Layout.BodyScrollableSection>
          <Center height="100%">
            <Loader />
          </Center>
        </Layout.BodyScrollableSection>
      </Layout.Body>
    </Layout.Root>
  );
};

export default Ordering;
